//@ts-nocheck
import {
	clearAllSpatialEaseOnKeyframe,
	getNearestFrameTime,
	setKeyValues,
} from "./keyframes";
import { mapToValues, addArrayValues } from "./math-utils";
import { applyBezierToPeak, getBezierInEase, getBezierOutEase } from "./bezier";
import { validateCubicBezierX } from "./validation";
import { getLatestSelectedKeyframeIndices } from "./keyframes";

export const elasticEaseLayer = (prop, req, selectedIndices) => {
	let values = req.values;
	let ognIdx = selectedIndices[selectedIndices.length - 2];
	let dstIdx = selectedIndices[selectedIndices.length - 1];
	let timeDelta = prop.keyTime(dstIdx) - prop.keyTime(ognIdx);
	let timeLerpMax = timeDelta * 5; //TODO: magic number here corresponds to UI visualization as initial bounce occurs at 1/5 of total time
	let valueLerpMax = prop.keyValue(dstIdx) - prop.keyValue(ognIdx);

	let keysframesToWrite = [];

	for (let i = 0; i < values.length - 1; i += 2) {
		//get time offset of peak keyframe
		let peakKfTimeOffset = values[i].dstLerpX * timeLerpMax;
		//get time offset of destination keyframe
		let dstKfTimeOffset = values[i + 1].dstLerpX * timeLerpMax;
		//get value offset of peak keyframe
		let peakKfValueOffset = mapToValues(valueLerpMax, values[i].dstLerpY);
		//get value offset of destination keyframe
		let dstKfValueOffset = mapToValues(valueLerpMax, values[i + 1].dstLerpY);
		//get peak keyframe total value
		let peakKfValue =
			addArrayValues(prop.keyValue(dstIdx), peakKfValueOffset) +
			valueLerpMax / 2;
		//get destination keyframe total value
		let dstKfValue =
			addArrayValues(prop.keyValue(dstIdx), dstKfValueOffset) +
			valueLerpMax / 2;

		//TODO: validation functions for values
		if (prop.matchName.includes("Opacity")) {
			if (peakKfValue > 100) {
				peakKfValue = 100;
			} else if (dstKfValue < 0) {
				dstKfValue = 0;
			}
		}

		//validate easing
		let cubicBez = validateCubicBezierX([
			1 - values[i].ognXCubic,
			1 - values[i].ognYCubic,
			values[i].dstXCubic,
			values[i].dstYCubic,
		]);
		let kf = {
			peakKfTimeOffset,
			dstKfTimeOffset,
			peakKfValue,
			dstKfValue,
			cubicBez,
		};
		keysframesToWrite.push(kf);
	}
	return keysframesToWrite;
};

//req object is being passed existing keyframes
export const createElasticKeyframesStop = (
	req,
	comp,
	prop,
	selectedIndices,
	newKeyframes
) => {
	//find first existing keyframe after startTime
	let firstExistingKeyframeTime = Infinity;
	let finalSelectedKeyframeTime = prop.keyTime(
		selectedIndices[selectedIndices.length - 1]
	);
	let ognSelectedKeyframeTime = prop.keyTime(
		selectedIndices[selectedIndices.length - 2]
	);
	//get first existing keyframe AFTER last selected index
	for (let i = 1; i <= prop.numKeys; i++) {
		let curKeyTime = prop.keyTime(i);
		if (curKeyTime > finalSelectedKeyframeTime) {
			firstExistingKeyframeTime = curKeyTime;
			//TODO: look into potential issues with removing continuous easing on existing keyframes
			if (
				prop.propertyValueType == PropertyValueType.ThreeD_SPATIAL ||
				prop.propertyValueType == PropertyValueType.TwoD_SPATIAL
			) {
				clearAllSpatialEaseOnKeyframe(prop, i);
				if (i + 1 <= prop.numKeys) clearAllSpatialEaseOnKeyframe(prop, i + 1);
				break;
			}
		}
	}

	for (let i = 0; i < newKeyframes.length; i++) {
		let {
			peakKfTimeOffset,
			dstKfTimeOffset,
			peakKfValue,
			dstKfValue,
			cubicBez,
		} = newKeyframes[i];

		let peakKeyframeWriteTime = ognSelectedKeyframeTime + peakKfTimeOffset;
		let dstKeyframeWriteTime = ognSelectedKeyframeTime + dstKfTimeOffset;
		if (req.config.keyframeWriteAtTimeBehavior === "nearest_frame") {
			peakKeyframeWriteTime = getNearestFrameTime(comp, peakKeyframeWriteTime);
			dstKeyframeWriteTime = getNearestFrameTime(comp, dstKeyframeWriteTime);
			if (peakKeyframeWriteTime === dstKeyframeWriteTime) return;
		}

		if (dstKeyframeWriteTime < firstExistingKeyframeTime) {
			//create peak keyframe
			let newPeakKf = prop.addKey(peakKeyframeWriteTime);
			//set peak keyframe value
			prop.setValueAtKey(newPeakKf, peakKfValue);
			//create destination keyframe
			let newDestKf = prop.addKey(dstKeyframeWriteTime);
			//set destination keyframe value
			prop.setValueAtKey(newDestKf, dstKfValue);
			//handle preexisting incoming ease on final selected keyframe
			if (i === 0) {
				let mirroredPeakEase = getBezierInEase(prop, newPeakKf, cubicBez);
				prop.setTemporalEaseAtKey(
					newPeakKf,
					mirroredPeakEase,
					mirroredPeakEase
				);
				let existingEaseIn = prop.keyInTemporalEase(newPeakKf - 1);
				let existingEaseOut = prop.keyOutTemporalEase(newPeakKf - 1);
				prop.setTemporalContinuousAtKey(newPeakKf - 1, false);
				prop.setTemporalEaseAtKey(
					newPeakKf - 1,
					existingEaseIn,
					existingEaseOut
				);
				prop.setTemporalEaseAtKey(newPeakKf + 1, mirroredPeakEase);
			} else {
				applyBezierToPeak(
					prop,
					newPeakKf,
					selectedIndices[selectedIndices.length - 1],
					cubicBez
				);
			}
		}
	}
	prop.removeKey(selectedIndices[selectedIndices.length - 1]);
};

export const createElasticKeyframesOverwrite = (
	req,
	comp,
	prop,
	selectedIndices,
	newKeyframes
) => {
	let finalSelectedKeyframeTime = prop.keyTime(
		selectedIndices[selectedIndices.length - 1]
	);
	let finalKeyframeWriteTime =
		newKeyframes[newKeyframes.length - 1].dstKfTimeOffset +
		finalSelectedKeyframeTime;
	let ognSelectedKeyframeTime = prop.keyTime(
		selectedIndices[selectedIndices.length - 2]
	);

	for (let i = prop.numKeys; i > 0; i--) {
		if (
			prop.keyTime(i) < finalKeyframeWriteTime &&
			prop.keyTime(i) > finalSelectedKeyframeTime
		) {
			prop.removeKey(i);
		}
	}

	for (let i = 0; i < newKeyframes.length; i++) {
		let {
			peakKfTimeOffset,
			dstKfTimeOffset,
			peakKfValue,
			dstKfValue,
			cubicBez,
		} = newKeyframes[i];

		let peakKeyframeWriteTime = ognSelectedKeyframeTime + peakKfTimeOffset;
		let dstKeyframeWriteTime = ognSelectedKeyframeTime + dstKfTimeOffset;
		if (req.config.keyframeWriteAtTimeBehavior === "nearest_frame") {
			peakKeyframeWriteTime = getNearestFrameTime(comp, peakKeyframeWriteTime);
			dstKeyframeWriteTime = getNearestFrameTime(comp, dstKeyframeWriteTime);
			if (peakKeyframeWriteTime === dstKeyframeWriteTime) return;
		}

		let newPeakKf = prop.addKey(peakKeyframeWriteTime);
		//set peak keyframe value
		prop.setValueAtKey(newPeakKf, peakKfValue);
		//create destination keyframe
		let newDestKf = prop.addKey(dstKeyframeWriteTime);
		//set destination keyframe value
		prop.setValueAtKey(newDestKf, dstKfValue);
		//handle preexisting incoming ease on final selected keyframe
		if (i === 0) {
			let mirroredPeakEase = getBezierInEase(prop, newPeakKf, cubicBez);
			prop.setTemporalEaseAtKey(newPeakKf, mirroredPeakEase, mirroredPeakEase);
			let existingEaseIn = prop.keyInTemporalEase(newPeakKf - 1);
			let existingEaseOut = prop.keyOutTemporalEase(newPeakKf - 1);
			prop.setTemporalContinuousAtKey(newPeakKf - 1, false);
			prop.setTemporalEaseAtKey(newPeakKf - 1, existingEaseIn, existingEaseOut);
			prop.setTemporalEaseAtKey(newPeakKf + 1, mirroredPeakEase);
		} else {
			applyBezierToPeak(
				prop,
				newPeakKf,
				selectedIndices[selectedIndices.length - 1],
				cubicBez
			);
		}
	}
	prop.removeKey(selectedIndices[selectedIndices.length - 1]);
};
